<template>
  <div>
    <!-- {{localTopicComponent}} -->

    <!-- title:'',
              description:'',
              content:'' -->
    <!-- <pre>{{localTopicComponent}}</pre> -->

    <!-- <pre>{{localTopicComponent}}</pre> -->
    <vs-row :key="index" v-for="(topicData, index) in localTopicComponent">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        :ref="'topicCard' + index"
      >
        <vs-card class="cstm-card w-full mb-4 collapse-cstm-card extra-card">
          <div class="collapse-item">
            <div
              class="flex justify-between header"
              slot="header"
              @click="topicData.isCollapseCard = !topicData.isCollapseCard"
              :class="{ activeCollapse: topicData.isCollapseCard }"
            >
              <h5>
                <div v-if="topicData.name == ''">Topic {{index + 1}}</div>
                <div v-else>{{topicData.name}}</div>
              </h5>
              <span class="material-icons">keyboard_arrow_down</span>
            </div>
            <div
              class="collapseContent"
              v-show="topicData.isCollapseCard"
              :class="{ active: topicData.isCollapseCard }"
            >
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-input
                    class="w-full mt-5"
                    placeholder="Title"
                    v-model="topicData.name"
                    v-validate="'required'"
                    name="Title"
                    data-vv-name="Title"
                  />
                </vs-col>

                <span
                  v-show="errors.has('CourseBuilder.Title')"
                  class="text-danger block"
                  >{{ errors.first('CourseBuilder.Title') }}</span
                >
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-textarea
                    class="w-full mt-5"
                    label="Description"
                    v-model="topicData.description"
                    :name="`topic_description${index}`"
                  />
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <!-- {{topicData.content.content}} -->
                  <content-component
                                  :file_repository_id="file_repository_id"

                  label="Content"
                    v-model="topicData.content.content"
                    v-if="topicData.showCourseContent || topicData.content.content !== ''"
                  ></content-component>
                </vs-col>
              </vs-row>

              <!-- Showing file -->
              <!-- <pre> {{topicData.filesInfo}}</pre> -->
             <!--  <div v-if="topicData.filesInfo">
                <file-showing :filesInfo="topicData.filesInfo"
                :file_ids="topicData.file_ids"
                ></file-showing>
              </div> -->
              <!-- <span v-if="topicData.filesInfo">
                        <div class="con-example-images">
                              Files
                              <vs-images>
                              <vs-image 
                              :src="files.file.file_path"
                              v-for="(files,index) in topicData.filesInfo" :key="index"
                                />
                              
                              </vs-images> 
                            </div>

    </span> -->

              <!-- Showing file -->

              <!-- File Upload Component -->
              <file-upload
                v-if="topicData.showFileContent"
                section_type="topiccomponent"
                :multiplefile="true"
                @getFileId="getIdFile"
                @deletedIndex="deletedIndex"
                :lesson_file_index="index"
                :file_repository_id="file_repository_id"
                :filesInfo="topicData.filesInfo"
              ></file-upload>


              <vs-row vs-type="flex" vs-justify="space-around">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="4.6"
                >
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    type="flat"
                    @click="
                      topicData.showCourseContent = !topicData.showCourseContent
                    "
                    >Content</vs-button
                  >
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="5.6"
                >
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    type="flat"
                    @click="
                      topicData.showFileContent = !topicData.showFileContent
                    "
                    >Attach File</vs-button
                  >
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-around">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="10"
                >
                  <vs-checkbox v-model="topicData.is_visible" v-if="section_type !== 'Topics'"
                    >Save to topic List</vs-checkbox
                  >
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="0.4"
                >
                  <vs-button
                    v-if="section_type != 'Topics'"
                    @click="removeTopic(index)"
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    type="flat"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { Testing } from '../mixins/testing-mixin'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import FileUpload from './FileUploadComponent.vue/FileUpload.vue'
import FileShowing from './FileUploadComponent.vue/FileShowing.vue'

export default {
  mixins: [Testing],
  components: {
    ContentComponent,
    FileUpload,
    FileShowing
  },
  inject: {
    $validator: '$validator'
  },

  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    section_type: {},
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    }
  },
  computed: {
    localTopicComponent: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    removeTopic (index) {
      setTimeout(() => {
        this.localTopicComponent.splice(index, 1)
        this.$vs.notify({
          title: 'Success',
          text: 'Topic deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      }, 1000)
    },
    getIdFile (obj) {
      if (Array.isArray(obj.file_id)) {
        

        this.localTopicComponent[obj.lesson_file_index].file_ids =  [...this.localTopicComponent[obj.lesson_file_index].file_ids, ...obj.file_id]

          
      } else {

        this.localTopicComponent[obj.lesson_file_index].file_ids.push(
          obj.file_id
        )
        
      }
    },
    deletedIndex (fileObject) {
      
      this.localTopicComponent[fileObject.lesson_file_index].filesInfo.splice(fileObject.fileIndex, 1)
      this.localTopicComponent[fileObject.lesson_file_index].file_ids.splice(fileObject.fileIndex, 1)
      
    }
  }
}
</script>